
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonBackButton,
  IonCard,
  IonCardHeader,
  IonCardContent,
} from '@ionic/vue';
import { defineComponent } from 'vue';

import LocalProducts from '../components/LocalProducts.vue';
import ContactForm from '../components/ContactForm.vue';

export default defineComponent({
  name: 'Products',
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonBackButton,
    IonCard,
    IonCardHeader,
    IonCardContent,
    LocalProducts,
    ContactForm,
  },
});
